import axios from "axios";
import refreshToken from "./RefreshTokenApi";
import { Mixpanel } from "../utils/Mixpanel";

const providerApi = axios.create({
    baseURL: `${process.env.REACT_APP_API_PROVIDER_HOST}/api/v1`,
    withCredentials: true,
    headers: {
        "Content-type": "application/json",
    },
});

providerApi.interceptors.response.use(
    (res) => {
        return res;
    },
    async (err) => {
        const originalConfig = err.config;
        if (!err.response) {
            Mixpanel.track("UI Provider API Unresponsive - network error to /" + originalConfig.url);
        }
        if (err.response && originalConfig.url !== "auth/refresh") {
            // Access Token was expired
            if (err.response.status === 401 && !originalConfig._retry) {
                try {
                    // the refresh token should be passed in via the cookie
                    await refreshToken.getAccessToken();
                    return providerApi(originalConfig);
                } catch (_error) {
                    return Promise.reject(_error);
                }
            }
        }

        return Promise.reject(err);
    }
);
export default providerApi;
